import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const NAMES = ['María G.', 'Ana P.', 'Lucía M.', 'Sofía R.', 'Valentina C.', 'Camila S.', 'Isabella T.', 'Paula B.', 'Daniela L.', 'Fernanda O.', 'Elena V.', 'Martina D.', 'Julia A.', 'Carmen R.', 'Laura M.', 'Gabriela H.', 'Andrea F.', 'Natalia K.', 'Florencia J.', 'Rocío N.'];
const LOCATIONS = [{
  city: 'Buenos Aires',
  flag: '🇦🇷'
}, {
  city: 'Santiago',
  flag: '🇨🇱'
}, {
  city: 'CDMX',
  flag: '🇲🇽'
}, {
  city: 'Lima',
  flag: '🇵🇪'
}, {
  city: 'Bogotá',
  flag: '🇨🇴'
}, {
  city: 'Montevideo',
  flag: '🇺🇾'
}, {
  city: 'Quito',
  flag: '🇪🇨'
}, {
  city: 'Córdoba',
  flag: '🇦🇷'
}, {
  city: 'Rosario',
  flag: '🇦🇷'
}, {
  city: 'Medellín',
  flag: '🇨🇴'
}, {
  city: 'Guayaquil',
  flag: '🇪🇨'
}, {
  city: 'San José',
  flag: '🇨🇷'
}, {
  city: 'Mendoza',
  flag: '🇦🇷'
}, {
  city: 'Valparaíso',
  flag: '🇨🇱'
}, {
  city: 'Guadalajara',
  flag: '🇲🇽'
}];
const TIME_AGO = ['Hace 2 min', 'Hace 5 min', 'Hace 8 min', 'Hace 12 min', 'Hace 15 min'];
const COVER_IMAGE = 'https://cdn.magicpatterns.com/uploads/c3dWU3DvqMuC37hAK3gshj/Portada_1.png';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: '',
    city: '',
    flag: '',
    timeAgo: ''
  });
  const timeoutsRef = useRef<number[]>([]);
  useEffect(() => {
    const addTimeout = (fn: () => void, ms: number) => {
      const id = window.setTimeout(fn, ms);
      timeoutsRef.current.push(id);
      return id;
    };
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const location = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      const timeAgo = TIME_AGO[Math.floor(Math.random() * TIME_AGO.length)];
      setNotificationData({
        name,
        city: location.city,
        flag: location.flag,
        timeAgo
      });
      setIsVisible(true);
      addTimeout(() => setIsVisible(false), 4500);
      const nextDelay = Math.floor(Math.random() * (18000 - 10000 + 1)) + 10000 + 4500;
      addTimeout(showNotification, nextDelay);
    };
    addTimeout(showNotification, 6000);
    return () => {
      timeoutsRef.current.forEach(id => window.clearTimeout(id));
      timeoutsRef.current = [];
    };
  }, []);
  return <AnimatePresence data-id="element-14">
      {isVisible && <motion.div initial={{
      x: 120,
      opacity: 0,
      scale: 0.8
    }} animate={{
      x: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      x: 120,
      opacity: 0,
      scale: 0.8
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 25
    }} className="fixed bottom-24 md:bottom-6 right-4 z-[45] max-w-[280px] w-full bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[#E8D5BE] p-3.5 flex items-center gap-3" data-id="element-15">
          <div className="flex-shrink-0" data-id="element-16">
            <img src={COVER_IMAGE} alt="MegaPack" className="w-12 h-14 object-cover rounded-lg shadow-sm" width={48} height={56} data-id="element-17" />
          </div>
          <div className="min-w-0" data-id="element-18">
            <p className="text-sm font-medium text-[#2D2A26] truncate" data-id="element-19">
              {notificationData.flag}{' '}
              <span className="font-bold" data-id="element-20">{notificationData.name}</span>
            </p>
            <p className="text-xs text-gray-500 truncate" data-id="element-21">
              {notificationData.city} · compró el MegaPack
            </p>
            <p className="text-[10px] text-[#2D7A65] font-medium mt-0.5" data-id="element-22">
              {notificationData.timeAgo}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}